import { FC } from 'react';
import { IconSVG, IconSVGComponentProps } from '../IconComponent';

export const ClassicPortfolio: FC<IconSVGComponentProps> = (props) => {
    return (
        <IconSVG viewBox="0 0 15 15" {...props}>
            <path
                d="M7 -3.0598e-07C8.38447 -3.66497e-07 9.73785 0.410542 10.889 1.17971C12.0401 1.94888 12.9373 3.04213 13.4672 4.32122C13.997 5.6003 14.1356 7.00776 13.8655 8.36563C13.5954 9.7235 12.9287 10.9708 11.9497 11.9497C10.9708 12.9287 9.7235 13.5954 8.36563 13.8655C7.00777 14.1356 5.6003 13.997 4.32122 13.4672C3.04213 12.9373 1.94888 12.0401 1.17971 10.889C0.410543 9.73785 -2.61972e-07 8.38447 -3.0598e-07 7L7 7L7 -3.0598e-07Z"
                fill="#75B2D2"
                strokeWidth="0"
            />
        </IconSVG>
    );
};
